import script from "./UserEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./UserEdit.vue?vue&type=script&setup=true&lang=js"

import "./UserEdit.vue?vue&type=style&index=0&id=46291611&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46291611"]])

export default __exports__